import React from 'react';

const SvgAttendance = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    {...props}
  >
    <path
      d="M15.6 10.5098H9.5385C9.52 10.9741 9.17075 11.2598 8.72 11.2598H7.2C6.73275 11.2598 6.3745 10.8503 6.38075 10.5098H0.4C0.18 10.5098 0 10.6785 0 10.8848V11.2598C0 12.0848 0.72 12.7598 1.6 12.7598H14.4C15.28 12.7598 16 12.0848 16 11.2598V10.8848C16 10.6785 15.82 10.5098 15.6 10.5098ZM14.4 1.88477C14.4 1.26602 13.86 0.759766 13.2 0.759766H2.8C2.14 0.759766 1.6 1.26602 1.6 1.88477V9.75977H14.4V1.88477ZM12.8 8.25977H3.2V2.25977H12.8V8.25977Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAttendance;
